import { render } from "./mobile.vue?vue&type=template&id=f5276eea&scoped=true"
import script from "./mobile.vue?vue&type=script&lang=js"
export * from "./mobile.vue?vue&type=script&lang=js"

import "./mobile.vue?vue&type=style&index=0&id=f5276eea&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dashcam_front/dashcam_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5276eea"]])

export default __exports__